import React from "react";
import Modal from "react-modal";

interface InfoPopupProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

const InfoPopup: React.FC<InfoPopupProps> = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="bg-[#161616] p-8 shadow-lg max-w-md mx-auto mt-10"
      overlayClassName="fixed inset-0 bg-black bg-opacity-80"
      contentLabel="Information about Shubin Project"
      ariaHideApp={false}
    >
      <div className="flex justify-end">
        <button
          onClick={onRequestClose}
          className="bg-[#C1282DFF] hover:bg-[#606060] py-2 px-4"
          aria-label="Close dialog"
        >
          ✖
        </button>
      </div>
      <h2 className="text-2xl mb-4">Info</h2>
      <p className="mb-4">
        This channel focuses on techno and house sets that are not available
        online or were previously available but for some reason were removed or
        expired. We upload them so everyone can enjoy listening!
      </p>
      <p className="mb-4">
        And with the new series called 'Exposé' we will showcase upcoming and
        innovative artists from the underground electronic music scene, with our
        first focus being on Bulgaria. With these series, we would like to
        contribute to the underground scene and attempt to bring light to
        artists that deserve it.
      </p>
      <p className="mb-4">
        Any content from the Lost Gems series has been previously available
        online. If the artists or other copyright holders do not permit the
        upload, please email us at:{" "}
        <a
          href="mailto:shubinproject@gmail.com"
          className="text-[#C1282DFF] underline"
        >
          shubinproject@gmail.com
        </a>
      </p>
    </Modal>
  );
};

export default InfoPopup;
